export const KEYS_TO_SANITIZE = {
  ATTACHMENT: ['text', 'footerText', 'title', 'description', 'name', 'value', 'content']
};
